import React, { useEffect, memo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import PrivateRoute from '../authentication/PrivateRoute';
import { getLastSegmentFromPath } from '../utils';
//import {useApplicationContext} from '../../context/ApplicationContext';

const ProfileConnectRoute = ({ component: Component, ...otherProps }) => {
    const location = useLocation();
    // a demonstration of how to get app config within this component
    // we should be using app config rather than environment vars here
    // const { globalState } = useApplicationContext();
    // const { config } = globalState;
    // console.log('CONFIG:', config);

    const ProfileConnect = () => {
        useEffect(() => {
            (async () => {
                const routeName = getLastSegmentFromPath(location.pathname);
                localStorage.setItem('profileConnectRedirectTo', routeName);
                const url = process.env.REACT_APP_PROFILE_CONNECT_URL;
                if (url) {
                    // The next line redirects to Profile Connect and THIS APP DIES.
                    window.location.href = url;
                } else {
                    console.error('REACT_APP_PROFILE_CONNECT_URL not defined in one of the .env files');
                }
            })();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        return <></>;
    };

    const hasRedirectedToProfileConnect = sessionStorage.getItem('hasRedirectedToProfileConnect');

    return (
        <PrivateRoute
            {...otherProps}
            component={hasRedirectedToProfileConnect ? Component : ProfileConnect}
            sessionTimeoutEnabled={otherProps.sessionTimeoutEnabled}
        />
    );
};

ProfileConnectRoute.displayName = 'ProfileConnectRoute';

ProfileConnectRoute.propTypes = {
    component: PropTypes.func.isRequired
};

export default memo(ProfileConnectRoute);
